var React = require('react');

function VimeoPlay (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M28 0H0V28H28V0ZM9.34618 22.3502L21.4538 15.3256V12.6752L9.34618 5.65065L7 6.97489V21.024L9.34618 22.3502Z","fill":"#FFF7F4"}));
}

VimeoPlay.defaultProps = {"width":"28","height":"28","viewBox":"0 0 28 28","fill":"none"};

module.exports = VimeoPlay;

VimeoPlay.default = VimeoPlay;
